import { useEffect, useRef } from 'react';

export default function SettingsTabs({ tabs, selected, onSelect }) {
  const list = useRef(null);
  useEffect(() => { list.current?.querySelector('[aria-selected="true"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' }); }, [selected]);
  const keyDown = (event, index) => {
    const keys = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 };
    if (!(event.key in keys)) return;
    event.preventDefault();
    list.current.children[keys[event.key]].focus();
    onSelect(keys[event.key]);
  };
  return <div ref={list} className="settings-tabs" role="tablist" aria-label="Settings sections">
    {tabs.map((tab, index) => <button key={tab.id} type="button" role="tab" aria-selected={selected === index} tabIndex={selected === index ? 0 : -1}
      onKeyDown={event => keyDown(event, index)} onClick={() => onSelect(index)}>{tab.content}</button>)}
  </div>;
}
